// @ts-nocheck
import React from 'react'
import Autocomplete from '@material-ui/lab/Autocomplete'
import TextField from './TextField'
import styled from 'styled-components'
import FormHelperText from '@material-ui/core/FormHelperText'

const StyledAutocomplete = styled(Autocomplete)`
	& .MuiInputBase-root {
		//padding: 0;
		padding: 0 13px;
		@media (max-width: 576px) {
			padding: 0 5px;
		}
	}
	& .MuiAutocomplete-popupIndicator {
		margin-inline-end: -11px;
	}
`

const StyledFormHelperText = styled(FormHelperText)`
	&.MuiFormHelperText-root {
		color: red;
		font-size: 10px;
		font-family: 'Work Sans', OpenSansHebrew;
	}
`

// TODO - Ben - make it generic with value and onChange passed from outside
const AutocompleteWithDropdown = ({ label, options, setValue, name, error, helperText, testId }) => {
	const [optionChosen, setOptionChosen] = React.useState('')

	const handleChange = (event, newValue) => {
		setOptionChosen(newValue)
		setValue(name, newValue, { shouldValidate: true })
	}

	return (
		<>
			<div>
				<StyledAutocomplete
					defaultValue=""
					value={optionChosen}
					getOptionLabel={(option) => option}
					getOptionSelected={(option) => option}
					options={options || []}
					onChange={(event, newValue) => handleChange(event, newValue)}
					style={{ textAlignLast: 'unset' }}
					renderInput={({ inputProps, ...params }) => (
						<TextField
							label={label}
							fullWidth
							fieldheight={34}
							isContactUs
							inputProps={{
								'data-testid': 'store-input',
								...inputProps,
							}}
							{...params}
						/>
					)}
					data-testid="store"
				/>
			</div>
			{error && <StyledFormHelperText>{helperText}</StyledFormHelperText>}
		</>
	)
}

export default AutocompleteWithDropdown
